module.exports = __webpack_public_path__ + "334aa073e87f7f8186fe76e8f27e355f.png";